
import BCXCollapsible from '@/components/molecules/BCXCollapsible.vue';
import { computed, defineComponent } from 'vue';
import BCXChevronSwitch from '@/components/molecules/BCXChevronSwitch.vue';

export default defineComponent({
  name: 'SettingsSection',
  components: { BCXChevronSwitch, BCXCollapsible },
  props: {
    title: {
      type: String, default: ''
    },
    sectionId: {
      type: String, default: ''
    },
    open: {
      type: Boolean,
      default: true
    }
  },
  setup(props, { emit }) {
    const isOpen = computed({
      get: () => props.open,
      set: (open:boolean) => emit('update:open', open)
    });

    return {
      isOpen,
    };
  }
});
